import React, { useEffect, useRef } from "react";
import emailjs from "@emailjs/browser";
import toast from "react-hot-toast";
import AOS from "aos";
import "aos/dist/aos.css";
import { BsGithub } from "react-icons/bs";
import { FaFacebook, FaLinkedin, FaFacebookMessenger } from "react-icons/fa";

const Contact = () => {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_ymmtrpc",
        "template_nq9ojah",
        form.current,
        "7GEdgEO4_1CUoafNl"
      )
      .then(
        (result) => {
          toast.success("Messege has been sent !");
          console.log(result.text);
          e.target.reset();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div>
      <section className="mt-[10%] max-w-[1500px] mx-auto lg:flex">
        <div
          data-aos="fade-right"
          data-aos-duration="1500"
          className="flex flex-col justify-center w-full p-8   lg:px-12 xl:px-32 lg:w-1/2"
        >
          <h1 className="text-3xl font-semibold text-gray-200 capitalize  lg:text-4xl">
            hire me.
          </h1>

          <p className="mt-4 text-gray-200 ">
            Ask me everything and I would love to hear from you
          </p>

          <div className="mt-6 md:mt-8">
            <h3 className="font-medium text-gray-400 ">Follow me</h3>

            <div className="flex gap-2 mt-4">
              <a
                className="text-3xl"
                href="https://www.linkedin.com/in/siam-shahriar/"
                target="_blank"
                rel="noreferrer"
              >
                <FaLinkedin></FaLinkedin>
              </a>
              <a
                className="text-3xl"
                href="https://github.com/siamshahriar"
                target="_blank"
                rel="noreferrer"
              >
                <BsGithub></BsGithub>
              </a>{" "}
              <a
                className="text-3xl"
                href="https://www.facebook.com/mdshahriarrahman.siam/"
                target="_blank"
                rel="noreferrer"
              >
                <FaFacebook></FaFacebook>
              </a>
              <a
                className="text-3xl"
                href="https://m.me/mdshahriarrahman.siam/"
                target="_blank"
                rel="noreferrer"
              >
                <FaFacebookMessenger></FaFacebookMessenger>
              </a>
            </div>
          </div>
        </div>

        <div
          data-aos="fade-left"
          data-aos-duration="1500"
          className="flex flex-col justify-center w-full p-8 pt-0 lg:w-1/2 lg:px-12 xl:px-24 "
        >
          <form ref={form} onSubmit={sendEmail}>
            <div className="-mx-2 md:items-center md:flex">
              <div className="flex-1 px-2">
                <label className="block mb-2 text-sm text-gray-400 ">
                  Full Name
                </label>
                <input
                  type="text"
                  name="user_name"
                  placeholder="John Doe"
                  className="block w-full px-5 py-3 mt-2 text-gray-200 placeholder-gray-400 bg-base-100 border border-gray-200 rounded-md   focus:border-blue-400 focus:ring-blue-400 focus:outline-none focus:ring focus:ring-opacity-40"
                />
              </div>

              <div className="flex-1 px-2 mt-4 md:mt-0">
                <label className="block mb-2 text-sm text-gray-400 ">
                  Email address
                </label>
                <input
                  type="email"
                  name="user_email"
                  placeholder="johndoe@example.com"
                  className="block w-full px-5 py-3 mt-2 text-gray-200 placeholder-gray-400 bg-base-100 border border-gray-200 rounded-md   focus:border-blue-400 focus:ring-blue-400 focus:outline-none focus:ring focus:ring-opacity-40"
                />
              </div>
            </div>

            <div className="w-full mt-4">
              <label className="block mb-2 text-sm text-gray-400 ">
                Message
              </label>
              <textarea
                name="message"
                className="block w-full h-32 px-5 py-3 mt-2 text-gray-200 placeholder-gray-400 bg-base-100 border border-gray-200 rounded-md md:h-56   focus:border-blue-400 focus:ring-blue-400 focus:outline-none focus:ring focus:ring-opacity-40"
                placeholder="Message"
              ></textarea>
            </div>

            <button
              type="submit"
              className="w-full px-6 py-3 mt-4 text-sm font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-500 rounded-md hover:bg-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-50"
            >
              get in touch
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default Contact;
